/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function LayoutPreset__Masonry(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'LayoutPreset__Masonry',
      'aria-hidden': true,
      focusable: false,
      width:  32 * scale,
      height: 20 * scale,
      viewBox: '0 0 32 20',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"clipPath":"url(#wf-svg-LayoutPreset__Masonry-__a)"},createElement('path', {"fill":"#D9D9D9","d":"M0 0h20v9H0z"}),createElement('path', {"stroke":"#D9D9D9","strokeOpacity":".25","d":"M.5.5h19v8H.5z"}),createElement('path', {"fill":"#D9D9D9","d":"M22 0h10v9H22z"}),createElement('path', {"stroke":"#D9D9D9","strokeOpacity":".25","d":"M22.5.5h9v8h-9z"}),createElement('path', {"fill":"#D9D9D9","d":"M0 11h10v9H0z"}),createElement('path', {"stroke":"#D9D9D9","strokeOpacity":".25","d":"M.5 11.5h9v8h-9z"}),createElement('path', {"fill":"#D9D9D9","d":"M12 11h20v9H12z"}),createElement('path', {"stroke":"#D9D9D9","strokeOpacity":".25","d":"M12.5 11.5h19v8h-19z"})),createElement('defs', null,createElement('clipPath', {"id":"wf-svg-LayoutPreset__Masonry-__a"},createElement('rect', {"width":"32","height":"20","rx":"2","fill":"#fff"}))))
}
